import CONSTANTS from "./Constants";

/**
 * Page-global stack of "escapable" layers (toggle-layer dialogs and popups).
 * A single document keydown listener routes Escape to the top-most layer's
 * close handler, so the innermost open layer always closes first. Layers are
 * removed by token (not strictly popped from the top), which is robust against
 * out-of-order / programmatic closes and makes teardown a safe no-op when a
 * layer was already removed.
 */

const layers = [];
let keydownHandler = null;
let nextToken = 1;

function isEscape(e) {
    return e.key === CONSTANTS.KEYS.ESCAPE
        || e.key === CONSTANTS.KEYS.ESC
        || e.keyCode === CONSTANTS.KEYS.CODES.ESC;
}

function onKeydown(e) {
    if (!isEscape(e) || layers.length === 0) {
        return;
    }
    e.preventDefault();
    layers[layers.length - 1].closeFn();
}

export function pushLayer(closeFn) {
    const token = nextToken++;
    layers.push({ token, closeFn });
    if (!keydownHandler) {
        keydownHandler = onKeydown;
        document.addEventListener('keydown', keydownHandler);
    }
    return token;
}

export function removeLayer(token) {
    const index = layers.findIndex((layer) => layer.token === token);
    if (index !== -1) {
        layers.splice(index, 1);
    }
    if (layers.length === 0 && keydownHandler) {
        document.removeEventListener('keydown', keydownHandler);
        keydownHandler = null;
    }
}
